<div class="header">
    <a routerLink="/">
        <img alt="logo" class="main-logo" src="assets/watchguard-logo.svg" />
    </a>
</div>
<mat-divider style="color: red;"></mat-divider>